import _ from 'lodash';

let queue = [];
let interval_id = null;

function process_save(state) {
  fetch('/donation-recovery', {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-CSRF-Token': document.head.querySelector("[name='csrf-token']")
        .attributes['content'].value
    },
    credentials: 'same-origin',
    method: 'POST',
    body: JSON.stringify(state)
  });
  //.then(response => console.log(response))
  //.catch(error => console.log(error));
}

function start_saving() {
  let last_step = 0;

  interval_id = setInterval(() => {
    if (queue.length === 0) {
      clearInterval(interval_id);
      interval_id = null;

      return;
    }

    queue = _.sortBy(queue, 'ts');
    const state = queue.shift();

    if (last_step === parseInt(state.step)) {
      return;
    }

    last_step = state.step;
    process_save(state);
  }, 500);
}

export async function save_donation_state(data) {
  if (!window.DONATION_RECOVERY) {
    return;
  }

  const {
    aid,
    amount,
    currentStep: step,
    details,
    queryStringParameters: { member_guid },
    url
  } = data;
  const ts = Date.now();

  queue.push({ aid, amount, step, details, member_guid, url, ts });

  if (interval_id === null) {
    start_saving();
  }
}

export function remove_from_donation_recovery(state) {
  return; // disable donation recovery

  /*
  const { aid, member_guid, is_recovery } = state;

  return fetch('/donation-recovery-remove', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': document.head.querySelector("[name='csrf-token']")
        .attributes['content'].value
    },
    credentials: 'same-origin',
    body: JSON.stringify({ aid, member_guid, is_recovery })
  });
  */
}
